import React, { useEffect, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap-5';
import TaskForm from './task_form';
import type { Activity } from 'bundles/connect/types';

type Props = {
  existingActivity: Activity | null;
  onHide: () => void;
  onUpdate: (activity: Activity) => Promise<void>;
}

export default function EditTaskModal({ existingActivity, onHide, onUpdate }: Props) {
  const [activity, setActivity] = useState<Activity | null>();
  const [saving, setSaving] = useState(false);
  const isValid = activity && activity.name !== '';

  useEffect(() => {
    if (existingActivity) setActivity({ ...existingActivity });
  }, [existingActivity]);

  const handleSave = () => {
    if (!activity) return;

    setSaving(true);

    onUpdate(activity)
      .then(onHide)
      .catch(() => {
        // errors
      })
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <Modal show={!!existingActivity} onHide={onHide}>
      <Modal.Header className="flex-row" closeButton>
        <Modal.Title as="h5">Edit Task</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column gap-3">
        {activity && <TaskForm activity={activity} onChange={setActivity} />}
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={saving || !isValid} variant="primary" onClick={handleSave}>
          {saving && <Spinner animation="border" />}
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
